import { useField } from "formik";
import { Form } from "react-bootstrap";
import { BaseInputProps } from "../../../../models";
import { FieldError } from "../error-message";
import { useMemo } from "react";
import { PatternFormat } from "react-number-format";

export interface FormikInputProps extends BaseInputProps {
    name: string;
    defaultValue?: string | number | readonly string[];
    mask?: string;
    isPhone?: boolean;
}

export const FormikInput = (props: FormikInputProps) => {
    const { id, name, label, mask, defaultValue, disabled, readonly, type, placeholder, isPhone, ...rest } = props;
    const [field] = useField(name);

    const format = useMemo(() => {
        if (mask) return mask;
        if (isPhone) return "(###) ###-####";
        return undefined;
    }, [mask, isPhone]);

    const hasMask = !!mask || isPhone;

    return (
        <Form.Group className="mb-2">
            {label && <Form.Label htmlFor={id ?? name}>{label}</Form.Label>}
            {mask ? (
                <Form.Control
                    id={id ?? name}
                    as={hasMask ? PatternFormat : undefined}
                    format={format}
                    mask={hasMask ? "_" : undefined}
                    defaultValue={defaultValue}
                    disabled={disabled}
                    readOnly={readonly}
                    type={type}
                    placeholder={placeholder}
                    {...rest}
                    {...field}
                />
            ) : (
                <Form.Control
                    id={id ?? name}
                    defaultValue={defaultValue}
                    disabled={disabled}
                    readOnly={readonly}
                    type={type}
                    placeholder={placeholder}
                    {...rest}
                    {...field}
                />
            )}
            <FieldError name={name} />
        </Form.Group>
    );
};
